export var PaymentProcessEventType;
(function(PaymentProcessEventType) {
    PaymentProcessEventType["INITIATE"] = "initiate";
    PaymentProcessEventType["SAVE"] = "save";
    PaymentProcessEventType["SAVE_ERROR"] = "save_error";
})(PaymentProcessEventType || (PaymentProcessEventType = {}));
export var DefaultPaymentOption;
(function(DefaultPaymentOption) {
    DefaultPaymentOption["CREDIT_OR_DEBIT_CARD"] = "CREDIT_OR_DEBIT_CARD";
    DefaultPaymentOption["BANK_ACCOUNT"] = "BANK_ACCOUNT";
})(DefaultPaymentOption || (DefaultPaymentOption = {}));
export var AdyenPaymentMethodType;
(function(AdyenPaymentMethodType) {
    AdyenPaymentMethodType["UNKNOWN"] = "UNKNOWN";
    AdyenPaymentMethodType["CARD"] = "scheme";
    AdyenPaymentMethodType["SEPA"] = "sepadirectdebit";
    AdyenPaymentMethodType["IDEAL"] = "ideal";
    AdyenPaymentMethodType["BACS"] = "directdebit_GB";
    // Linking new Sofort instrument is no longer supported
    AdyenPaymentMethodType["SOFORT"] = "directEbanking";
})(AdyenPaymentMethodType || (AdyenPaymentMethodType = {}));
